import { render, staticRenderFns } from "./SupportTicketList.vue?vue&type=template&id=0dc5188a&scoped=true"
import script from "./SupportTicketList.vue?vue&type=script&lang=js"
export * from "./SupportTicketList.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketList.vue?vue&type=style&index=0&id=0dc5188a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5188a",
  null
  
)

export default component.exports